export default {
  MuiList: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff !important'
      },
      padding: {
        paddingBottom: '0',
        paddingTop: '0'
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        width: 'fit-content !important',
        padding: '0',
        paddingRight: '0.5rem', // 8px
        marginBottom: '1rem',
        transition: 'ease-in-out 0.4s',
        backgroundColor: '#ffffff !important',
        '&.Mui-selected': {
          backgroundColor: '#ffffff !important',
          color: '#83A06D !important',
          borderRadius: '0.5rem', // 8px
          '& .MuiListItemText-root': {
            '& .MuiTypography-root': {
              textDecoration: 'underline',
              fontWeight: 'bold !important'
            }
          }
        },
        '&$selected:hover': {
          transition: 'ease-in-out 0.4s',
          fontWeight: 'bold !important',
          background: '#ffffff !important',
          color: '#83A06D',
          borderRadius: '0.5rem' // 8px
        },
        '&:hover': {
          transition: 'ease-in-out 0.4s',
          fontWeight: 'bold !important',
          background: '#ffffff',
          color: '#83A06D',
          borderRadius: '0.5rem' // 8px
        }
      },
      container: {
        margin: '0.5rem 0' // 8px 0px
      },
      button: {
        width: '100%',
        height: 'auto'
      },
      dense: {
        paddingTop: '0',
        paddingBottom: '0'
      }
    }
  },
  MuiListItemText: {
    styleOverrides: {
      multiline: {
        marginTop: '0',
        marginBottom: '0'
      },
      primary: {
        fontSize: '0.875rem' // 14px
      }
    }
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: '2.4375rem' // 39px
      }
    }
  }
};
